import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { convertGamevyPatternToLine } from "gamevy/integration/gamevy-utils";
import { TGRGameSchema, TGRScatterSchema } from "integration/schema/tgr-game-schema";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";

export class TGRFreeSpinWinResultBuilder implements ResultBuilder {

    public filter(data: any, record?: Record): boolean {
        if (data.reason === "scatter") {
            return true;
        }
        return false;
    }

    public build(record: Record, data: any, additionalData?: any): Result[] {
        const results: Result[] = [];

        const freespinWinResult: FreespinWinResult = new FreespinWinResult();
        freespinWinResult.freespinsWon = data.freeSpins;
        results.push(freespinWinResult);

        const gameData: TGRGameSchema = additionalData.game;

        gameData.scatter.forEach((scatter: TGRScatterSchema) => {
            const scatterResult: ScatterResult = new ScatterResult();
            scatterResult.linkedResult = freespinWinResult;
            scatterResult.symbolType = "S";
            scatterResult.positions = convertGamevyPatternToLine(scatter.pattern);
            scatterResult.matches = scatterResult.positions.length;
            results.push(scatterResult);
        });

        return results;
    }
}

export const tgrFreeSpinWinResultBuilder = new TGRFreeSpinWinResultBuilder();
